module.exports = __webpack_public_path__ + "img/metro-icon-img.0db9dd3e.svg";